// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footerWrapper":"footer_footerWrapper__uxvSC"};